import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "../components/AuthShell";
import { Button, Input } from "../components/ui";
import { publicApi, apiError } from "../lib/api";

export default function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  // Fragments never reach HTTP/access logs. Keep the credential in component
  // memory and remove it from the visible URL/history entry immediately.
  const [token] = useState(() => new URLSearchParams(location.hash.replace(/^#/, "")).get("token") || "");
  useEffect(() => {
    if (location.hash || location.search) navigate(location.pathname, { replace: true });
  }, [location.hash, location.search, location.pathname, navigate]);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await publicApi.post("/auth/reset-password", { token, password });
      toast.success("Password updated! Please sign in.");
      navigate("/login");
    } catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Choose a new password" footer={<Link to="/login" className="text-primary font-bold">← Back to sign in</Link>}>
      {!token ? (
        <div className="bg-coral/10 border-2 border-coral/20 rounded-3xl p-6 text-center font-bold text-ink">
          This reset link is missing its token. Request a new one.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Input label="New password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" required minLength={6} data-testid="reset-password" />
          <Button type="submit" size="lg" className="w-full" disabled={loading} data-testid="reset-submit">
            {loading ? "Saving…" : "Save new password"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
